module.exports = __webpack_public_path__ + "bc3aa95.woff2";